import type { TFunction } from 'i18next';
import type { VehicleListResponseBucketKeys } from '../../../data/vehicles/useVehicles';

type FilterType = 'select' | 'range' | 'managedBy' | 'branch';

type FilterConfig = {
  step?: number;
  unit?: string;
  unitBefore?: boolean;
  type: FilterType;
  getLabelFromKey?: (t: TFunction, key: string) => string;
};

export const filterConfigMap: Record<VehicleListResponseBucketKeys, FilterConfig> = {
  'ad.price': {
    type: 'range',
    step: 1000,
    unit: 'kr',
  },
  arrived: {
    type: 'select',
    getLabelFromKey: (t: TFunction, key: string) =>
      key === 'true'
        ? t('filter.arrived', { ns: 'salesAndPurchasingVehicles' })
        : t('filter.notArrived', { ns: 'salesAndPurchasingVehicles' }),
  },
  hasContentDeclaration: {
    type: 'select',
  },
  'vehicle.isAssociatedWithRisk': {
    type: 'select',
  },
  branchId: {
    type: 'branch',
  },
  enrichment: {
    type: 'select',
  },
  archived: {
    type: 'select',
  },
  'processes_tasks.process': {
    type: 'select',
  },
  'tasks_tasks.displayName': {
    type: 'select',
  },
  managedBy: {
    type: 'managedBy',
  },
  numberOfImages: {
    type: 'range',
    step: 1,
    unit: 'images',
  },
  odometerValueAsScandinavianMiles: {
    type: 'range',
    step: 10,
    unit: 'scandinavianMiles',
  },
  odometerValueAsKm: {
    type: 'range',
    step: 100,
    unit: 'distanceUnit_one',
  },
  'progressState.type': {
    type: 'select',
  },
  'purchaseInfo.type': {
    type: 'select',
  },
  'purchaseInfo.valuation': {
    type: 'range',
    step: 1000,
    unit: 'kr',
  },
  purchased: {
    type: 'select',
    getLabelFromKey: (t: TFunction, key: string) =>
      key === 'true'
        ? t('filter.purchased', { ns: 'salesAndPurchasingVehicles' })
        : t('filter.notPurchased', { ns: 'salesAndPurchasingVehicles' }),
  },
  'station.displayName': {
    type: 'select',
  },
  visibility: {
    type: 'select',
  },
  'tasks.displayName': {
    type: 'select',
  },
  'tasks.process': {
    type: 'select',
  },
  'tasks.state': {
    type: 'select',
  },
  'vehicle.colorName': {
    type: 'select',
  },
  'vehicle.drivingWheel': {
    type: 'select',
  },
  'vehicle.gearboxType': {
    type: 'select',
  },
  'vehicle.manufacturer': {
    type: 'select',
  },
  'vehicle.modelSeries': {
    type: 'select',
  },

  'vehicle.modelYear': {
    type: 'range',
    step: 1,
    unit: 'year',
    unitBefore: true,
  },
  'vehicle.segment': {
    type: 'select',
  },
  'vehicle.fuelTypesString': {
    type: 'select',
  },
  'vehicle.modelName': {
    type: 'select',
  },
  'insights.publishedDays': {
    type: 'select',
  },
  'insights.stockDays': {
    type: 'select',
  },
  'insights.inactive': {
    type: 'select',
  },
  'insights.unprepared': {
    type: 'select',
  },
  'insights.publishedWithoutContentDeclaration': {
    type: 'select',
  },
  'ad.hasManufacturerPackaging': {
    type: 'select',
  },
  'ad.deductibleVat': {
    type: 'select',
  },
  type: {
    type: 'select',
  },
  erpName: {
    type: 'select',
  },
  soldAt: {
    type: 'select',
  },
  'finnPublication.state': {
    type: 'select',
  },
  'blocketPublication.status': {
    type: 'select',
  },
  'internalPublication.state': {
    type: 'select',
  },
  status: {
    type: 'select',
  },
  lastUpdatedAt: {
    type: 'select',
  },
};
